import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const DashboardSvg = ({ width, height, color }: Props) => (
  <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.2 9.9H0.9C0.661305 9.9 0.432387 9.99482 0.263604 10.1636C0.0948211 10.3324 0 10.5613 0 10.8V17.1C0 17.3387 0.0948211 17.5676 0.263604 17.7364C0.432387 17.9052 0.661305 18 0.9 18H7.2C7.43869 18 7.66761 17.9052 7.8364 17.7364C8.00518 17.5676 8.1 17.3387 8.1 17.1V10.8C8.1 10.5613 8.00518 10.3324 7.8364 10.1636C7.66761 9.99482 7.43869 9.9 7.2 9.9ZM6.3 16.2H1.8V11.7H6.3V16.2ZM17.1 0H10.8C10.5613 0 10.3324 0.0948211 10.1636 0.263604C9.99482 0.432387 9.9 0.661305 9.9 0.9V7.2C9.9 7.43869 9.99482 7.66761 10.1636 7.8364C10.3324 8.00518 10.5613 8.1 10.8 8.1H17.1C17.3387 8.1 17.5676 8.00518 17.7364 7.8364C17.9052 7.66761 18 7.43869 18 7.2V0.9C18 0.661305 17.9052 0.432387 17.7364 0.263604C17.5676 0.0948211 17.3387 0 17.1 0V0ZM16.2 6.3H11.7V1.8H16.2V6.3ZM17.1 9.9H10.8C10.5613 9.9 10.3324 9.99482 10.1636 10.1636C9.99482 10.3324 9.9 10.5613 9.9 10.8V17.1C9.9 17.3387 9.99482 17.5676 10.1636 17.7364C10.3324 17.9052 10.5613 18 10.8 18H17.1C17.3387 18 17.5676 17.9052 17.7364 17.7364C17.9052 17.5676 18 17.3387 18 17.1V10.8C18 10.5613 17.9052 10.3324 17.7364 10.1636C17.5676 9.99482 17.3387 9.9 17.1 9.9ZM16.2 16.2H11.7V11.7H16.2V16.2ZM7.2 0H0.9C0.661305 0 0.432387 0.0948211 0.263604 0.263604C0.0948211 0.432387 0 0.661305 0 0.9V7.2C0 7.43869 0.0948211 7.66761 0.263604 7.8364C0.432387 8.00518 0.661305 8.1 0.9 8.1H7.2C7.43869 8.1 7.66761 8.00518 7.8364 7.8364C8.00518 7.66761 8.1 7.43869 8.1 7.2V0.9C8.1 0.661305 8.00518 0.432387 7.8364 0.263604C7.66761 0.0948211 7.43869 0 7.2 0V0ZM6.3 6.3H1.8V1.8H6.3V6.3Z"
      fill={color}
    />
  </svg>
)

DashboardSvg.defaultProps = {
  width: 18,
  height: 18,
  color: colors.Primary.GreyText
}

export default DashboardSvg
